import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PayorInvoiceDataService {

    billing: any;
    billingRef: any;
    invoiceListNoPlanned: any;
    invoiceListPlannedOnly: any;
    invoiceList: any = {};
    invoices: any;

    constructor() { }

    filterRecordsBasedOnPolicy(data: any, policyNumber: string) {
        let _billing: any = {};
        _billing.policyNumber = policyNumber;
        _billing.invoices = data.invoices ? data.invoices.filter(x => x.policyNumber === policyNumber) : [];
        _billing.payments = data.payments ? data.payments.filter(x => x.policyNumber === policyNumber) : [];
        _billing.paymentRequests = data.paymentRequests ? data.paymentRequests.filter(x => x.policyNumber === policyNumber) : [];
        _billing.documents = data.documents ? data.documents.filter(x => x.policyNumber === policyNumber) : [];
        _billing.disbursements = data.disbursements ? data.disbursements.filter(x => x.policyNumber === policyNumber) : [];
        _billing.account = {};
        _billing.account.balanceDue = data.account.balanceDue;
        return _billing;
    }

    populateBillingInvoices(billing: any) {
        this.billing = billing;
        this.invoiceListNoPlanned = new Array();
        for (let i = 0; i < this.billing.invoices?.length; i++) {
            if (this.billing.invoices[i].status != 'Planned') {
                if (this.billing.invoices[i].status === 'Due') {
                    if (parseFloat(this.billing.invoices[i].dueAmount) > 0.00) {
                        this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                    }
                }
            }
        }
        return this.invoiceListNoPlanned;
    }

    populatePaymentRequests(billing: any, filterType: any) {
        this.invoiceListNoPlanned = new Array();
        if (filterType === 'account-summary' || filterType === 'billing') {
            for (let i = 0; i < billing.paymentRequests?.length; i++) {
                if (!billing.paymentRequests[i].status.includes('Closed') && !billing.paymentRequests[i].status.includes('Drafted-Error') && billing.paymentRequests[i].paymentTechStatus != 'Payment Reversed') {
                    if (billing.payments.find(x => x.invoiceNumber == billing.paymentRequests[i].invoiceNumber)) {
                        //Invoice was found - don't do anything.
                    } else {
                        //If no invoice was found in payments array, then we add the paymentRequest item here.
                        this.invoiceListNoPlanned.push(billing.paymentRequests[i]);
                        if (billing.invoices.find(x => x.invoiceNumber == billing.paymentRequests[i].invoiceNumber)) {
                            this.invoiceListNoPlanned[this.invoiceListNoPlanned.length - 1].dueDate = billing.invoices.find(x => x.invoiceNumber == billing.paymentRequests[i].invoiceNumber).dueDate;
                        }
                    }
                }
            }
        } else {
            for (let i = 0; i < this.billing.paymentRequests.length; i++) {
                if (!this.billing.paymentRequests[i].status.includes('Closed') && !this.billing.paymentRequests[i].status.includes('Drafted-Error') && !this.billing.paymentRequests[i].paymentTechStatus.includes('Payment Reversed')) {
                    if (this.billing.payments.find(x => x.invoiceNumber == this.billing.paymentRequests[i].invoiceNumber)) {
                        //Invoice was found - don't do anything.
                    } else {
                        this.invoiceListNoPlanned.push(this.billing.paymentRequests[i]);
                    }
                }
            }
        }

        return this.invoiceListNoPlanned;
    }

    populateTransactionalInvoices(billing: any, isCanadaUser: boolean) {
        this.billing = billing;
        this.invoiceListNoPlanned = new Array();
        this.invoiceListPlannedOnly = new Array();
        for (let i = 0; i < this.billing.invoices?.length; i++) {
            if (this.billing.invoices[i].status != 'Planned') {
                if (this.billing.invoices[i].status === 'Due') {
                    if (parseFloat(this.billing.invoices[i].dueAmount) > 0.00) {
                        this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                    }
                }
                else if (this.billing.paymentRequests.find(x => x.invoiceNumber == this.billing.invoices[i].invoiceNumber)) {
                    if (this.billing.paymentRequests.find(x => x.invoiceNumber == this.billing.invoices[i].invoiceNumber && (x.status === 'Closed-Declined' || x.status === 'Drafted-Declined' || x.status === 'Closed-Error' || x.status === 'Drafted-Error'))) {
                        if (this.billing.payments.find(x => x.invoiceNumber == this.billing.invoices[i].invoiceNumber)) {
                            //Invoice already has a payment. Do nothing.
                            if (parseFloat(this.billing.invoices[i].dueAmount) > 0.00) {
                                this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                            }
                        } else {
                            //We know this invoice # has a closed-declined. We know it does NOT have a payment.
                            //If we see a payment drafted, do not add back the 'billed' status invoice
                            if (this.billing.paymentRequests.find(x => x.invoiceNumber == this.billing.invoices[i].invoiceNumber && x.paymentTechStatus == 'Payment Drafted')) {
                                //FEB 28 2022 UPDATE:
                                //Needed to comment out this code, because it caused both the "Due" and "Payment Drafted" to show for the same invoice in account summary.
                                //Commenting out this code makes it so that only the latest status, "Payment Drafted", will show to the user.

                                //Don't add the billing invoice here, unless due amount is greater than 0
                                // if (parseFloat(this.billing.invoices[i].dueAmount) > 0.00) {
                                //   this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                                // }
                            } else {
                                //Invoice does not have a payment yet, and the paymentrequest was closed-declined. Add this item back to the invoices list. Also check for payment reversals.
                                if (this.billing.paymentRequests.find(x => x.invoiceNumber == this.billing.invoices[i].invoiceNumber && (x.paymentTechStatus == 'Payment Reversed'))) {
                                    if (this.billing.payments.find(x => x.invoiceNumber == this.billing.invoices[i].invoiceNumber)) {
                                        if (parseFloat(this.billing.invoices[i].dueAmount) > 0.00) {
                                            this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                                        }
                                    } else {
                                        if (isCanadaUser) {
                                            this.billing.invoices[i].paymentTechStatus = "Payment Reversed";
                                            this.billing.invoices[i].status = "";
                                        }
                                        this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                                    }
                                } else {
                                    this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                                }
                            }
                        }
                    } else if (this.billing.paymentRequests.find(x => x.invoiceNumber == this.billing.invoices[i].invoiceNumber && (x.paymentTechStatus == 'Payment Reversed' || x.status == 'Closed-Approved'))) {
                        let pr = this.billing.paymentRequests.find(x => x.invoiceNumber == this.billing.invoices[i].invoiceNumber && (x.paymentTechStatus == 'Payment Reversed' || x.status == 'Closed-Approved'));
                        if (this.billing.payments.find(x => x.publicId == pr.relatedPayment && (x.status === 'Reversed'))) {
                            if (this.billing.payments.find(x => x.invoiceNumber == this.billing.invoices[i].invoiceNumber)) {
                                if (parseFloat(this.billing.invoices[i].dueAmount) > 0.00) {
                                    this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                                }
                            } else {
                                this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                            }
                        }
                    }
                } else if (this.billing.payments.find(x => x.invoiceNumber == this.billing.invoices[i].invoiceNumber)) {
                    //Invoice was found - don't do anything.
                    if (parseFloat(this.billing.invoices[i].dueAmount) > 0.00) {
                        this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                    }
                } else {
                    this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                }
            } else {
                this.invoiceListPlannedOnly.push(this.billing.invoices[i]);
            }
        }

        this.invoiceList.invoiceListNoPlanned = this.invoiceListNoPlanned;
        this.invoiceList.invoiceListPlannedOnly = this.invoiceListPlannedOnly;

        return this.invoiceList;
    }

    populateUpcomingInvoices(billing: any, isCanadaUser: boolean) {
        this.billing = billing;
        this.invoiceListNoPlanned = new Array();

        for (let i = 0; i < this.billing.invoices.length; i++) {
            if (this.billing.invoices[i].status != 'Planned') {
                if (this.billing.invoices[i].status === 'Due') {
                    if (parseFloat(this.billing.invoices[i].dueAmount) > 0.00) {
                        this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                    }
                }
                else if (this.billing.paymentRequests.find(x => x.invoiceNumber == this.billing.invoices[i].invoiceNumber)) {
                    if (this.billing.paymentRequests.find(x => x.invoiceNumber == this.billing.invoices[i].invoiceNumber && (x.status === 'Closed-Declined' || x.status === 'Drafted-Declined' || x.status === 'Closed-Error' || x.status === 'Drafted-Error'))) {
                        if (this.billing.payments.find(x => x.invoiceNumber == this.billing.invoices[i].invoiceNumber)) {
                            if (parseFloat(this.billing.invoices[i].dueAmount) > 0.00) {
                                this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                            }
                        } else {
                            //We know this invoice # has a closed-declined. We know it does NOT have a payment.
                            //If we see a payment drafted, do not add back the 'billed' status invoice
                            if (this.billing.paymentRequests.find(x => x.invoiceNumber == this.billing.invoices[i].invoiceNumber && x.paymentTechStatus == 'Payment Drafted')) {
                                //FEB 28 2022 UPDATE:
                                //Needed to comment out this code, because it caused both the "Due" and "Payment Drafted" to show for the same invoice in account summary.
                                //Commenting out this code makes it so that only the latest status, "Payment Drafted", will show to the user. 
                                //Don't add the billing invoice here, unless due amount is greater than 0
                                // if (parseFloat(this.billing.invoices[i].dueAmount) > 0.00) {
                                //   this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                                // }
                            } else {
                                //Invoice does not have a payment yet, and the paymentrequest was closed-declined. Add this item back to the invoices list. Also check for payment reversals.
                                if (this.billing.paymentRequests.find(x => x.invoiceNumber == this.billing.invoices[i].invoiceNumber && (x.paymentTechStatus == 'Payment Reversed'))) {
                                    if (this.billing.payments.find(x => x.invoiceNumber == this.billing.invoices[i].invoiceNumber)) {
                                        if (parseFloat(this.billing.invoices[i].dueAmount) > 0.00) {
                                            this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                                        }
                                    } else {
                                        if (isCanadaUser) {
                                            this.billing.invoices[i].paymentTechStatus = "Payment Reversed";
                                            this.billing.invoices[i].status = "";
                                        }
                                        this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                                    }
                                } else {
                                    this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                                }
                            }
                        }
                    } else if (this.billing.paymentRequests.find(x => x.invoiceNumber == this.billing.invoices[i].invoiceNumber && (x.paymentTechStatus == 'Payment Reversed' || x.status == 'Closed-Approved'))) {
                        let pr = this.billing.paymentRequests.find(x => x.invoiceNumber == this.billing.invoices[i].invoiceNumber && (x.paymentTechStatus == 'Payment Reversed' || x.status == 'Closed-Approved'));
                        if (this.billing.payments.find(x => x.publicId == pr.relatedPayment && (x.status === 'Reversed'))) {
                            if (this.billing.payments.find(x => x.invoiceNumber == this.billing.invoices[i].invoiceNumber)) {
                                if (parseFloat(this.billing.invoices[i].dueAmount) > 0.00) {
                                    this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                                }
                            } else {
                                this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                            }
                        }
                    }
                } else if (this.billing.payments.find(x => x.invoiceNumber == this.billing.invoices[i].invoiceNumber)) {
                    if (parseFloat(this.billing.invoices[i].dueAmount) > 0.00) {
                        this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                    }
                } else {
                    this.invoiceListNoPlanned.push(this.billing.invoices[i]);
                }
            }
        }

        return this.invoiceListNoPlanned;
    }
}